import "styles/font.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import App from "./App";

import dayjs from "dayjs";
import "dayjs/locale/ko";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

// react-query
import { RQProvider } from "providers/RQProvider";

// redux
import store, { persistor } from "redux/store";

// TagManager Module
import ReactGA from "react-ga4";
// import { MSWComponent } from "lib/msw/setup/msw-component";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale("ko");

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
ReactGA.initialize(GA_MEASUREMENT_ID);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <RQProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename="/">
          <App />
          {/* <MSWComponent /> */}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </RQProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
